<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="ip地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'ip', validatorRules.ip]" placeholder="请输入ip地址" v-bind:disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'memo', validatorRules.memo]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['ipStatus', validatorRules.ipStatus]" :trigger-change="true" dictCode="on_off" placeholder="请选择状态"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "BusCommonMessageBlackIpModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        disabled:false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          ip: {rules: [
            {required: true,message:"请输入ip地址!"},
           { validator: (rule, value, callback) =>{ 
              if(value===''){
                callback();
             }else{
               if(!(/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(value))){
                 callback(new Error("ip格式错误"));
               }
               validateDuplicateValue('bus_common_message_black_ip', 'ip', value, this.model.id, callback)
             }
              }},
          ]},
          memo: {rules: [
          ]},
          ipStatus: {rules: [
          ]},
        },
        url: {
          add: "/base/busCommonMessageBlackIp/add",
          edit: "/base/busCommonMessageBlackIp/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
		this.form.resetFields();
		this.model = Object.assign({}, {"ipStatus":"1"});
		this.visible = true;
		this.disabled=false;
		this.$nextTick(() => {
		  this.form.setFieldsValue(pick(this.model,'ip','memo','createTime','ipStatus'))
		})
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
		this.disabled=true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'ip','memo','createTime','ipStatus'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'ip','memo','createTime','ipStatus'))
      },

      
    }
  }
</script>